import * as React from "react";
import { Route } from "react-router-dom";

import { ConnectedRouter } from "connected-react-router";

import * as Actions from "../../actions";
import * as ROUTES from "../../constants/routes";
import Firebase, { withFirebase } from "../../Firebase";
import * as States from "../../models/state";
import createStore, { history } from "../../store";

import Home from "../Home";
import SignInPage from "../SignIn";

import * as firebase from "firebase";

import { Provider } from "react-redux";

import withAuthorization from "../Session";

export const store = createStore(States.DEFAULT_STATE);

interface IProps {
  firebase: Firebase;
}

class App extends React.Component<IProps, any> {
  private listener: firebase.Unsubscribe;

  public componentDidMount(): void {
    this.listener = this.props.firebase.auth.onAuthStateChanged(
      (u: firebase.User | null) =>
        store.dispatch(Actions.Auth.AuthStateChanged(u))
    );
  }

  public componentWillUnmount(): void {
    // Unsubscribe the listener.
    this.listener();
  }

  public render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Route
            exact={true}
            path={ROUTES.LANDING}
            component={withAuthorization(
              (u: firebase.User | null) => u !== null
            )(Home)}
          />
          <Route path={ROUTES.SIGN_IN} component={SignInPage} />
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default withFirebase(App);



// WEBPACK FOOTER //
// ./src/components/App/App.tsx